<template>
	<div class="personal-loan-status-setting">
		<StatusMenu :tab_name="'insuranceStatus'" />
		<InsuranceFormStatusModal ref="form_modal" :mainStatusOpt="mainStatusOpt" @close="getStatus"/>
		
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col cols="6">
					<h2 class="listing-title d-inline-block mb-0">Insurance Status Setting</h2>
				</b-col>
				<b-col cols="6" class="text-right ">
					<b-button variant="primary" class="btn-header" @click="$refs.form_modal.show()">Create New</b-button>
				</b-col>
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<b-card no-body>
				<b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>
				<!-- SEARCH INPUT -->
				<b-col cols="12">
					<b-row class="d-flex align-items-center justify-content-md-between">
						<b-col cols="12" md="6" class="d-md-flex">
							<base-input label="Search" v-model="searchQuery" v-on:input="debouncedHandler"
								prepend-icon="fas fa-search" placeholder="Search...">
							</base-input>
						</b-col>
					</b-row>
				</b-col>

				<!-- TABLE LIST -->
				<div class="table-listings">
					<el-table ref="multipleTable" v-loading="isLoading" :data="queriedData" style="width: 100%;"
						@selection-change="selectionChange">
						<el-table-column type="selection" width="55" fixed="left" height="500"></el-table-column>

						<!-- STATUS NAME COLUMN -->
						<el-table-column prop="status" label="Status Name" sortable>
							<template slot-scope="scope">
								<p class="mb-0" :class="scope.row.group === 'main' ? 'text-primary font-weight-bold' : ''">
									{{ scope.row.status }}
								</p>
							</template>
						</el-table-column>

						<!-- STATUS GROUP COLUMN -->
						<el-table-column prop="group" label="Status Group" sortable>
							<template slot-scope="scope">
								<p class="text-capitalize" :class="scope.row.group === 'main' ? 'text-primary font-weight-bold' : ''">{{
									scope.row.group }}</p>
							</template>
						</el-table-column>

						<!-- PARENT STATUS COLUMN -->
						<el-table-column prop="parent_status" label="Main Status" sortable>
							<template slot-scope="scope">
								<p class="font-weight-bold text-primary">{{ scope.row.parent_status }}</p>
							</template>
						</el-table-column>

						<!-- TAT DAY -->
						<el-table-column prop="tat_day" label="TAT Day" sortable>
							<template slot-scope="scope">
								<p v-if="scope.row.tat_stop != 1" class="mb-0">{{ scope.row.tat_day }} Days</p>
								<p v-else class="mb-0 text-danger">TAT Stop</p>
							</template>
						</el-table-column>

						<!-- STATUS CREATED BY COLUMN -->
						<el-table-column prop="created_by" label="Created By" sortable>
							<template slot-scope="scope">
								<div>
									{{ _gHlp.getValue(scope.row,'created_by_detail.name') }}
								</div>
							</template>

						</el-table-column>

						<!-- STATUS CREATED AT COLUMN -->
						<el-table-column prop="created_at" label="Date Created" sortable>
							<template slot-scope="scope">
								<div v-if="scope.row.created_at">
									{{ scope.row.created_at | dateFormatString }}
								</div>
							</template>

						</el-table-column>

						<!-- STATUS ACTIONS COLUMN -->
						<el-table-column width="55" fixed="right">
							<template slot-scope="scope">
								<el-dropdown :tabindex="scope.row.id" class="py-2">
									<b class="el-dropdown-link">
										<b-icon icon="three-dots-vertical">
										</b-icon>
									</b>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item @click.native="$refs.form_modal.show(scope.row)">
											Edit
										</el-dropdown-item>
										<el-dropdown-item @click.native="deleteStatus(scope.row.status_id)">
											Delete
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</template>

						</el-table-column>

					</el-table>
				</div>

				<!-- FOOTER -->
				<div slot="footer" class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap">
					<div class="d-flex align-items-center mb-3">
						<p class="card-category mb-0 text-secondary">
							Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

							<span v-if="selectedRows.length">
								&nbsp; &nbsp; {{ selectedRows.length }} rows selected
							</span>
						</p>

						<span class="mb-0 ml-4">Rows:</span>

						<el-select class="select-primary pagination-select mx-2" v-model="pagination.perPage"
							placeholder="Per page">
							<el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
								:value="item">
							</el-option>
						</el-select>

					</div>
					<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
						:total="total" @change="paginationChanged($event)">
					</base-pagination>
				</div>
			</b-card>
		</b-container>
	</div>
</template>
<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import StatusMenu from '@/views/Configurations/StatusMenu'
import InsuranceFormStatusModal from '@/views/Configurations/CaseStatuses/InsuranceStatusSettings/InsuranceStatusModals/InsuranceFormStatusModal'
import { useProductStore } from '@/stores/productStore'
import { mapActions } from 'pinia'
import { debounce, swal } from '@/assets/js/httpImports.js'

export default {
	components: {
		InsuranceFormStatusModal,
		StatusMenu,
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
	},
	mixins: [clientPaginationMixin],
	data() {
		return {
			isLoading: true,
			propsToSearch: ['status'],
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			debouncedHandler: '',
			TableColumn: [{
				type: 'selection'
			}],
			tableData: [],
			mainStatusOpt: [],
			status_data: {},
			pagination: {
				perPageOptions: [5, 10, 25, 50, 100, 500]
			},
		}
	},
	created() {
		this.getStatus()
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
		}, 500);
	},
	methods: {
		...mapActions(useProductStore, ['getCaseStatusList', 'deleteCaseStatus']),
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		paginationChanged(page) {
			this.pagination.currentPage = page
		},
		getStatus() {
			this.isLoading = true
			this.getCaseStatusList('status-insurance', {}, 'no_paginate').then(resp => {
				this.tableData = _gHlp.getValue(resp, 'data');
				this.mainStatusOpt = this.tableData.filter((itm) => itm.group == 'main')
				this.isLoading = false;
			}).catch(err => {
				_gNotif.errorFunction(err)
				this.isLoading = false;
			});
		},
		deleteStatus(status_id) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteCaseStatus('status-insurance', status_id).then(resp => {
						this.getStatus()
						_gNotif.notifySuccess('<b>Status: </b> - Successfully Deleted.')
					}).catch(err => {
						_gNotif.errorFunction(err)
					})
				}
			})
		},
	}
}
</script>